import Vue from "vue";
import { API_HOST } from "@/settings/server";
import axios from "axios";
import $store from "@/store";

class ContractTextService {
    constructor() {
        this.cancelTokenSource = axios.CancelToken.source();
    }

    cancelRequests() {
        this.cancelTokenSource.cancel("GET requests canceled by the user.");
        this.cancelTokenSource = axios.CancelToken.source();
    }

    get() {
        return Vue.axios.get(`${API_HOST}/api/contract`, {
            headers: {
                Authorization: `Bearer ${$store.getters.accessToken}`
            },
            cancelToken: this.cancelTokenSource.token
        });
    }

    post(text) {
        return Vue.axios.post(
            `${API_HOST}/api/contract`,
            JSON.stringify(text), // send as JSON
            {
                headers: {
                    Authorization: `Bearer ${$store.getters.accessToken}`,
                    "Content-Type": "application/json"
                }
            }
        );
    }
}

export default new ContractTextService();
